module.exports = __webpack_public_path__ + "images/index/home.eacb95e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/yuang/home.jpg
// module id = cQD4
// module chunks = 21